import SecurityView from "./SecurityView";

const SecurityContainer = () => {
  return <SecurityView />;
};

export default SecurityContainer;
